[
	[
		"aa",
		"Afar",
		"Afaraf"
	],
	[
		"ab",
		"Abkhaz",
		"аҧсуа бызшәа"
	],
	[
		"ae",
		"Avestan",
		"avesta"
	],
	[
		"af",
		"Afrikaans",
		"Afrikaans"
	],
	[
		"ak",
		"Akan",
		"Akan"
	],
	[
		"am",
		"Amharic",
		"አማርኛ"
	],
	[
		"an",
		"Aragonese",
		"aragonés"
	],
	[
		"ar",
		"Arabic",
		"اللغة العربية"
	],
	[
		"as",
		"Assamese",
		"অসমীয়া"
	],
	[
		"av",
		"Avaric",
		"авар мацӀ"
	],
	[
		"ay",
		"Aymara",
		"aymar aru"
	],
	[
		"az",
		"Azerbaijani",
		"azərbaycan dili"
	],
	[
		"ba",
		"Bashkir",
		"башҡорт теле"
	],
	[
		"be",
		"Belarusian",
		"беларуская мова"
	],
	[
		"bg",
		"Bulgarian",
		"български език"
	],
	[
		"bh",
		"Bihari",
		"भोजपुरी"
	],
	[
		"bi",
		"Bislama",
		"Bislama"
	],
	[
		"bm",
		"Bambara",
		"bamanankan"
	],
	[
		"bn",
		"Bengali",
		"বাংলা"
	],
	[
		"bo",
		"Tibetan",
		"བོད་ཡིག"
	],
	[
		"br",
		"Breton",
		"brezhoneg"
	],
	[
		"bs",
		"Bosnian",
		"bosanski jezik"
	],
	[
		"ca",
		"Catalan",
		"Català"
	],
	[
		"ce",
		"Chechen",
		"нохчийн мотт"
	],
	[
		"ch",
		"Chamorro",
		"Chamoru"
	],
	[
		"co",
		"Corsican",
		"corsu"
	],
	[
		"cr",
		"Cree",
		"ᓀᐦᐃᔭᐍᐏᐣ"
	],
	[
		"cs",
		"Czech",
		"čeština"
	],
	[
		"cu",
		"Old Church Slavonic",
		"ѩзыкъ словѣньскъ"
	],
	[
		"cv",
		"Chuvash",
		"чӑваш чӗлхи"
	],
	[
		"cy",
		"Welsh",
		"Cymraeg"
	],
	[
		"da",
		"Danish",
		"dansk"
	],
	[
		"de",
		"German",
		"Deutsch"
	],
	[
		"dv",
		"Divehi",
		"ދިވެހި"
	],
	[
		"dz",
		"Dzongkha",
		"རྫོང་ཁ"
	],
	[
		"ee",
		"Ewe",
		"Eʋegbe"
	],
	[
		"el",
		"Greek",
		"Ελληνικά"
	],
	[
		"en",
		"English",
		"English"
	],
	[
		"eo",
		"Esperanto",
		"Esperanto"
	],
	[
		"es",
		"Spanish",
		"Español"
	],
	[
		"et",
		"Estonian",
		"eesti"
	],
	[
		"eu",
		"Basque",
		"euskara"
	],
	[
		"fa",
		"Persian",
		"فارسی"
	],
	[
		"ff",
		"Fula",
		"Fulfulde"
	],
	[
		"fi",
		"Finnish",
		"suomi"
	],
	[
		"fj",
		"Fijian",
		"Vakaviti"
	],
	[
		"fo",
		"Faroese",
		"føroyskt"
	],
	[
		"fr",
		"French",
		"Français"
	],
	[
		"fy",
		"Western Frisian",
		"Frysk"
	],
	[
		"ga",
		"Irish",
		"Gaeilge"
	],
	[
		"gd",
		"Scottish Gaelic",
		"Gàidhlig"
	],
	[
		"gl",
		"Galician",
		"galego"
	],
	[
		"gu",
		"Gujarati",
		"ગુજરાતી"
	],
	[
		"gv",
		"Manx",
		"Gaelg"
	],
	[
		"ha",
		"Hausa",
		"هَوُسَ"
	],
	[
		"he",
		"Hebrew",
		"עברית"
	],
	[
		"hi",
		"Hindi",
		"हिन्दी"
	],
	[
		"ho",
		"Hiri Motu",
		"Hiri Motu"
	],
	[
		"hr",
		"Croatian",
		"Hrvatski"
	],
	[
		"ht",
		"Haitian",
		"Kreyòl ayisyen"
	],
	[
		"hu",
		"Hungarian",
		"magyar"
	],
	[
		"hy",
		"Armenian",
		"Հայերեն"
	],
	[
		"hz",
		"Herero",
		"Otjiherero"
	],
	[
		"ia",
		"Interlingua",
		"Interlingua"
	],
	[
		"id",
		"Indonesian",
		"Bahasa Indonesia"
	],
	[
		"ie",
		"Interlingue",
		"Interlingue"
	],
	[
		"ig",
		"Igbo",
		"Asụsụ Igbo"
	],
	[
		"ii",
		"Nuosu",
		"ꆈꌠ꒿ Nuosuhxop"
	],
	[
		"ik",
		"Inupiaq",
		"Iñupiaq"
	],
	[
		"io",
		"Ido",
		"Ido"
	],
	[
		"is",
		"Icelandic",
		"Íslenska"
	],
	[
		"it",
		"Italian",
		"Italiano"
	],
	[
		"iu",
		"Inuktitut",
		"ᐃᓄᒃᑎᑐᑦ"
	],
	[
		"ja",
		"Japanese",
		"日本語"
	],
	[
		"jv",
		"Javanese",
		"basa Jawa"
	],
	[
		"ka",
		"Georgian",
		"ქართული"
	],
	[
		"kg",
		"Kongo",
		"Kikongo"
	],
	[
		"ki",
		"Kikuyu",
		"Gĩkũyũ"
	],
	[
		"kj",
		"Kwanyama",
		"Kuanyama"
	],
	[
		"kk",
		"Kazakh",
		"қазақ тілі"
	],
	[
		"kl",
		"Kalaallisut",
		"kalaallisut"
	],
	[
		"km",
		"Khmer",
		"ខេមរភាសា"
	],
	[
		"kn",
		"Kannada",
		"ಕನ್ನಡ"
	],
	[
		"ko",
		"Korean",
		"한국어"
	],
	[
		"kr",
		"Kanuri",
		"Kanuri"
	],
	[
		"ks",
		"Kashmiri",
		"कश्मीरी"
	],
	[
		"ku",
		"Kurmanji (Kurdish)",
		"Kurmancî"
	],
	[
		"kv",
		"Komi",
		"коми кыв"
	],
	[
		"kw",
		"Cornish",
		"Kernewek"
	],
	[
		"ky",
		"Kyrgyz",
		"Кыргызча"
	],
	[
		"la",
		"Latin",
		"latine"
	],
	[
		"lb",
		"Luxembourgish",
		"Lëtzebuergesch"
	],
	[
		"lg",
		"Ganda",
		"Luganda"
	],
	[
		"li",
		"Limburgish",
		"Limburgs"
	],
	[
		"ln",
		"Lingala",
		"Lingála"
	],
	[
		"lo",
		"Lao",
		"ລາວ"
	],
	[
		"lt",
		"Lithuanian",
		"lietuvių kalba"
	],
	[
		"lu",
		"Luba-Katanga",
		"Tshiluba"
	],
	[
		"lv",
		"Latvian",
		"Latviski"
	],
	[
		"mg",
		"Malagasy",
		"fiteny malagasy"
	],
	[
		"mh",
		"Marshallese",
		"Kajin M̧ajeļ"
	],
	[
		"mi",
		"Māori",
		"te reo Māori"
	],
	[
		"mk",
		"Macedonian",
		"македонски јазик"
	],
	[
		"ml",
		"Malayalam",
		"മലയാളം"
	],
	[
		"mn",
		"Mongolian",
		"Монгол хэл"
	],
	[
		"mn-Mong",
		"Traditional Mongolian",
		"ᠮᠣᠩᠭᠣᠯ ᠬᠡᠯᠡ"
	],
	[
		"mr",
		"Marathi",
		"मराठी"
	],
	[
		"ms",
		"Malay",
		"Bahasa Melayu"
	],
	[
		"ms-Arab",
		"Jawi Malay",
		"بهاس ملايو"
	],
	[
		"mt",
		"Maltese",
		"Malti"
	],
	[
		"my",
		"Burmese",
		"ဗမာစာ"
	],
	[
		"na",
		"Nauru",
		"Ekakairũ Naoero"
	],
	[
		"nb",
		"Norwegian Bokmål",
		"Norsk bokmål"
	],
	[
		"nd",
		"Northern Ndebele",
		"isiNdebele"
	],
	[
		"ne",
		"Nepali",
		"नेपाली"
	],
	[
		"ng",
		"Ndonga",
		"Owambo"
	],
	[
		"nl",
		"Dutch",
		"Nederlands"
	],
	[
		"nn",
		"Norwegian Nynorsk",
		"Norsk Nynorsk"
	],
	[
		"no",
		"Norwegian",
		"Norsk"
	],
	[
		"nr",
		"Southern Ndebele",
		"isiNdebele"
	],
	[
		"nv",
		"Navajo",
		"Diné bizaad"
	],
	[
		"ny",
		"Chichewa",
		"chiCheŵa"
	],
	[
		"oc",
		"Occitan",
		"occitan"
	],
	[
		"oj",
		"Ojibwe",
		"ᐊᓂᔑᓈᐯᒧᐎᓐ"
	],
	[
		"om",
		"Oromo",
		"Afaan Oromoo"
	],
	[
		"or",
		"Oriya",
		"ଓଡ଼ିଆ"
	],
	[
		"os",
		"Ossetian",
		"ирон æвзаг"
	],
	[
		"pa",
		"Punjabi",
		"ਪੰਜਾਬੀ"
	],
	[
		"pi",
		"Pāli",
		"पाऴि"
	],
	[
		"pl",
		"Polish",
		"Polski"
	],
	[
		"ps",
		"Pashto",
		"پښتو"
	],
	[
		"pt",
		"Portuguese",
		"Português"
	],
	[
		"qu",
		"Quechua",
		"Runa Simi"
	],
	[
		"rm",
		"Romansh",
		"rumantsch grischun"
	],
	[
		"rn",
		"Kirundi",
		"Ikirundi"
	],
	[
		"ro",
		"Romanian",
		"Română"
	],
	[
		"ru",
		"Russian",
		"Русский"
	],
	[
		"rw",
		"Kinyarwanda",
		"Ikinyarwanda"
	],
	[
		"sa",
		"Sanskrit",
		"संस्कृतम्"
	],
	[
		"sc",
		"Sardinian",
		"sardu"
	],
	[
		"sd",
		"Sindhi",
		"सिन्धी"
	],
	[
		"se",
		"Northern Sami",
		"Davvisámegiella"
	],
	[
		"sg",
		"Sango",
		"yângâ tî sängö"
	],
	[
		"si",
		"Sinhala",
		"සිංහල"
	],
	[
		"sk",
		"Slovak",
		"slovenčina"
	],
	[
		"sl",
		"Slovenian",
		"slovenščina"
	],
	[
		"sn",
		"Shona",
		"chiShona"
	],
	[
		"so",
		"Somali",
		"Soomaaliga"
	],
	[
		"sq",
		"Albanian",
		"Shqip"
	],
	[
		"sr",
		"Serbian",
		"српски језик"
	],
	[
		"ss",
		"Swati",
		"SiSwati"
	],
	[
		"st",
		"Southern Sotho",
		"Sesotho"
	],
	[
		"su",
		"Sundanese",
		"Basa Sunda"
	],
	[
		"sv",
		"Swedish",
		"Svenska"
	],
	[
		"sw",
		"Swahili",
		"Kiswahili"
	],
	[
		"ta",
		"Tamil",
		"தமிழ்"
	],
	[
		"te",
		"Telugu",
		"తెలుగు"
	],
	[
		"tg",
		"Tajik",
		"тоҷикӣ"
	],
	[
		"th",
		"Thai",
		"ไทย"
	],
	[
		"ti",
		"Tigrinya",
		"ትግርኛ"
	],
	[
		"tk",
		"Turkmen",
		"Türkmen"
	],
	[
		"tl",
		"Tagalog",
		"Tagalog"
	],
	[
		"tn",
		"Tswana",
		"Setswana"
	],
	[
		"to",
		"Tonga",
		"faka Tonga"
	],
	[
		"tr",
		"Turkish",
		"Türkçe"
	],
	[
		"ts",
		"Tsonga",
		"Xitsonga"
	],
	[
		"tt",
		"Tatar",
		"татар теле"
	],
	[
		"tw",
		"Twi",
		"Twi"
	],
	[
		"ty",
		"Tahitian",
		"Reo Tahiti"
	],
	[
		"ug",
		"Uyghur",
		"ئۇيغۇرچە‎"
	],
	[
		"uk",
		"Ukrainian",
		"Українська"
	],
	[
		"ur",
		"Urdu",
		"اردو"
	],
	[
		"uz",
		"Uzbek",
		"Ўзбек"
	],
	[
		"ve",
		"Venda",
		"Tshivenḓa"
	],
	[
		"vi",
		"Vietnamese",
		"Tiếng Việt"
	],
	[
		"vo",
		"Volapük",
		"Volapük"
	],
	[
		"wa",
		"Walloon",
		"walon"
	],
	[
		"wo",
		"Wolof",
		"Wollof"
	],
	[
		"xh",
		"Xhosa",
		"isiXhosa"
	],
	[
		"yi",
		"Yiddish",
		"ייִדיש"
	],
	[
		"yo",
		"Yoruba",
		"Yorùbá"
	],
	[
		"za",
		"Zhuang",
		"Saɯ cueŋƅ"
	],
	[
		"zh",
		"Chinese",
		"中文"
	],
	[
		"zu",
		"Zulu",
		"isiZulu"
	],
	[
		"zh-CN",
		"Chinese (China)",
		"简体中文"
	],
	[
		"zh-HK",
		"Chinese (Hong Kong)",
		"繁體中文（香港）"
	],
	[
		"zh-TW",
		"Chinese (Taiwan)",
		"繁體中文（臺灣）"
	],
	[
		"zh-YUE",
		"Cantonese",
		"廣東話"
	],
	[
		"ast",
		"Asturian",
		"Asturianu"
	],
	[
		"chr",
		"Cherokee",
		"ᏣᎳᎩ ᎦᏬᏂᎯᏍᏗ"
	],
	[
		"ckb",
		"Sorani (Kurdish)",
		"سۆرانی"
	],
	[
		"cnr",
		"Montenegrin",
		"crnogorski"
	],
	[
		"csb",
		"Kashubian",
		"Kaszëbsczi"
	],
	[
		"gsw",
		"Swiss German",
		"Schwiizertütsch"
	],
	[
		"jbo",
		"Lojban",
		"la .lojban."
	],
	[
		"kab",
		"Kabyle",
		"Taqbaylit"
	],
	[
		"ldn",
		"Láadan",
		"Láadan"
	],
	[
		"lfn",
		"Lingua Franca Nova",
		"lingua franca nova"
	],
	[
		"lzz",
		"Lazuri",
		"ლაზური ნენა"
	],
	[
		"moh",
		"Mohawk",
		"Kanienʼkéha"
	],
	[
		"nds",
		"Low German",
		"Plattdüütsch"
	],
	[
		"ota",
		"Ottoman Turkish",
		"لسان عثمانی"
	],
	[
		"pdc",
		"Pennsylvania Dutch",
		"Pennsilfaani-Deitsch"
	],
	[
		"sco",
		"Scots",
		"Scots"
	],
	[
		"sma",
		"Southern Sami",
		"Åarjelsaemien Gïele"
	],
	[
		"smj",
		"Lule Sami",
		"Julevsámegiella"
	],
	[
		"szl",
		"Silesian",
		"ślůnsko godka"
	],
	[
		"tok",
		"Toki Pona",
		"toki pona"
	],
	[
		"vai",
		"Vai",
		"ꕙꔤ"
	],
	[
		"xal",
		"Kalmyk",
		"Хальмг келн"
	],
	[
		"xmf",
		"Mingrelian",
		"მარგალური ნინა"
	],
	[
		"zba",
		"Balaibalan",
		"باليبلن"
	],
	[
		"zgh",
		"Standard Moroccan Tamazight",
		"ⵜⴰⵎⴰⵣⵉⵖⵜ"
	],
	[
		"nan-TW",
		"Hokkien (Taiwan)",
		"臺語 (Hô-ló話)"
	]
]